import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import axios from 'axios'
import 'bootstrap'
import Toaster from '@meforma/vue-toaster'
import Vue3TouchEvents from 'vue3-touch-events'
import Toast from 'vue-toastification'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import VueClickAway from 'vue3-click-away'
import VueYandexMetrika from 'vue3-yandex-metrika'
import 'vue-toastification/dist/index.css'
dayjs.extend(customParseFormat)

const baseUrl = 'https://lk.k31.ru/api'

axios.defaults.baseURL = baseUrl

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)
const toastOptions = {
  onMounted: (_, toastApp) => {
    toastApp.use(router)
  }
}
app.use(Toast, toastOptions)
app.use(VueYandexMetrika, {
  id: '65064187',
  router: router,
  env: process.env.NODE_ENV,
  // env: 'production',
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
    triggerEvent: true
  }
})
app.use(VueClickAway)
app.use(Vue3TouchEvents)
app.provide('dayjs', dayjs)
app
  .use(Toaster, { position: 'top-right' })
  .provide('toast', app.config.globalProperties.$toast)

if (process.env.NODE_ENV === 'development') {
  app.mount('#app')
} else {
  let isStarted = false
  document.addEventListener('deviceready', function () {
    isStarted = true
    app.mount('#app')
  })
  setTimeout(function () {
    if (!isStarted) {
      app.mount('#app')
    }
  }, 3000)
}

document.addEventListener('gesturestart', (event) => {
  event.preventDefault()
})
